import { CookieService } from '../../../../../services/cookie-service';
import { CHURN_WIN_BACK_COOKIE_KEY, EligibleAccountStatuses } from './helpers';

export const useShouldShowChurnWinBackBanner = (accountIssueStatus) => {
  const isEligible = EligibleAccountStatuses.includes(accountIssueStatus);
  const coupon = CookieService.getCookieValue(CHURN_WIN_BACK_COOKIE_KEY);

  return isEligible && !!coupon;
};
